import { Record } from 'immutable'

export interface IAttachmentSizes {
  h100w100?: string
  h100w150?: string
  h200w250?: string
  h500?: string
  h500w500?: string
  h50w50?: string
  h75w100?: string
  original?: string
  w500?: string
  w750?: string
}

const AttachmentSizesRecord = Record({
  h100w100: undefined,
  h100w150: undefined,
  h200w250: undefined,
  h500: undefined,
  h500w500: undefined,
  h50w50: undefined,
  h75w100: undefined,
  original: undefined,
  w500: undefined,
  w750: undefined,
})

export class AttachmentSizes extends AttachmentSizesRecord
  implements IAttachmentSizes {
  public static fromJS(initialState?: Partial<IAttachmentSizes>) {
    return new AttachmentSizes(initialState)
  }

  public readonly h100w100?: string
  public readonly h100w150?: string
  public readonly h200w250?: string
  public readonly h500?: string
  public readonly h500w500?: string
  public readonly h50w50?: string
  public readonly h75w100?: string
  public readonly original?: string
  public readonly w500?: string
  public readonly w750?: string

  constructor(initialState?: Partial<AttachmentSizes>) {
    initialState ? super(initialState) : super()
  }
}
